const DEV_AFFILIATION_URL = 'http://localhost:8080/affiliation';
const PROD_AFFILIATION_URL = 'https://keyfiyathava.ahooai.ir/affiliation';

export const AFFILIATION_URL = __DEV__ ? DEV_AFFILIATION_URL : PROD_AFFILIATION_URL;
